import { render, staticRenderFns } from "./LoginSalon.vue?vue&type=template&id=90c2b010"
import script from "./LoginSalon.vue?vue&type=script&lang=js"
export * from "./LoginSalon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports